import { ReactNode } from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { ColorName, COLORS, fillColors } from '@connect-x-app/shared-ui';

export type SwitchProps = {
  className?: string;
  icon?: ReactNode;
  isDisabled?: boolean;
  name?: string;
  onChange: (value: boolean) => void;
  size?: (typeof switchSizes)[number];
  style?: StyleProp<TextStyle>;
  testId?: string;
  type?: (typeof switchModeTypes)[number];
  value: boolean;
};

export const switchModeTypes = ['primary', 'disabled', 'accent', 'caution', 'warning', 'primary-white'];

export const switchSizes = ['s', 'm', 'l'] as const;

export const SWITCH_SIZES = {
  l: {
    height: 4,
    width: 6.4,
  },
  m: {
    height: 3.2,
    width: 5.6,
  },
  s: {
    height: 2.4,
    width: 4.0,
  },
};

export type SwitchStyleSet = {
  thumb: {
    background: ColorName;
  };
  track: {
    background: ColorName;
    border: ColorName;
  };
};

export const SWITCH_MODE_COMBINATIONS: Record<(typeof switchModeTypes)[number], Record<'off' | 'on', SwitchStyleSet>> = {
  accent: {
    off: {
      thumb: { background: fillColors['$fill-accent-light'] },
      track: { background: fillColors['$fill-white'], border: fillColors['$fill-accent-light'] },
    },
    on: {
      thumb: { background: fillColors['$fill-white'] },
      track: { background: fillColors['$fill-accent-light'], border: fillColors['$fill-accent-light'] },
    },
  },
  caution: {
    off: {
      thumb: { background: fillColors['$fill-caution-dark'] },
      track: { background: fillColors['$fill-white'], border: fillColors['$fill-caution-dark'] },
    },
    on: {
      thumb: { background: fillColors['$fill-white'] },
      track: { background: fillColors['$fill-caution-dark'], border: fillColors['$fill-caution-dark'] },
    },
  },
  disabled: {
    off: {
      thumb: { background: fillColors['$fill-disabled-light'] },
      track: { background: COLORS.tango.$01, border: COLORS.zulu.$03 },
    },
    on: {
      thumb: { background: fillColors['$fill-white'] },
      track: { background: fillColors['$fill-disabled-light'], border: fillColors['$fill-disabled-light'] },
    },
  },
  primary: {
    off: {
      thumb: { background: fillColors['$fill-primary'] },
      track: { background: fillColors['$fill-white'], border: COLORS.zulu.$06 },
    },
    on: {
      thumb: { background: fillColors['$fill-white'] },
      track: { background: fillColors['$fill-primary'], border: COLORS.zulu.$06 },
    },
  },
  'primary-white': {
    off: {
      thumb: { background: fillColors['$fill-white'] },
      track: { background: fillColors['$fill-primary'], border: fillColors['$fill-white'] },
    },
    on: {
      thumb: { background: fillColors['$fill-primary'] },
      track: { background: fillColors['$fill-white'], border: COLORS.zulu.$06 },
    },
  },
  warning: {
    off: {
      thumb: { background: fillColors['$fill-warning-dark'] },
      track: { background: fillColors['$fill-white'], border: fillColors['$fill-warning-dark'] },
    },
    on: {
      thumb: { background: fillColors['$fill-white'] },
      track: { background: fillColors['$fill-warning-dark'], border: fillColors['$fill-warning-dark'] },
    },
  },
};
